module.exports = "<v-layout mb-3 row wrap >\n  <v-btn fab :color=\"vModel === demand.key ? 'secondary' : 'primary' \" v-for=\"(demand, index) in dtKindsOfDemand\" :key=\"demand.key\" \n  :flat=\"vModel !== demand.key\" small @click=\"handleClick(demand.key)\" :disabled=\"disabled\" >\n    <v-icon>{{demand.icon}}</v-icon>\n  </v-btn>\n  <!-- <v-btn fab color=\"secondary\" :flat=\"vModel !== 'mail'\" small @click=\"handleClick('mail')\">\n    <v-icon color=\"primary\">icon-mail</v-icon>\n  </v-btn> -->\n\n</v-layout>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ticket/components/ticket-modal-origin-demand/template.html
// module id = 56HU
// module chunks = 0